module.exports = __webpack_public_path__ + "static/img/fa-solid-900.85224f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fa-solid-900.svg
// module id = SztR
// module chunks = 0